import { FirebaseError } from 'firebase/app';

// A missing composite index also answers `failed-precondition`, so the message check is load-bearing.
const terminatedMessage = 'client has already been terminated';

// FirebaseError's constructor resets the prototype, so no FirestoreError subclass survives `instanceof`.
export const isClientTerminatedError = (error: unknown): boolean => {
  if (!(error instanceof FirebaseError)) {
    return false;
  }

  return (
    error.code === 'failed-precondition' &&
    error.message.includes(terminatedMessage)
  );
};
